<template>
<div class="ActivityWithdrawal">
    <withdrawalList :param="param" :flag="flag"></withdrawalList>
</div>
</template>

<script>
import WithdrawalList from 'views/tools/nationalDistribution/capital/WithdrawalList.vue'
export default {
    name: 'ActivityWithdrawal',
    data() {
        return {
            param: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : '',
                status: '',
                title: this.$route.query.title ? this.$route.query.title : ''
            },
            flag: true
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        WithdrawalList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityWithdrawal {
}
</style>
